<template>
	<div>
    <v-card
      v-for="(docGroup, index) in documentGroups"
      :key="index"
      class="mt-4"
    >
      <library-list
        :documents="docGroup.documents"
        color="blue"
        :header="docGroup.documentType"
        :library-user-role-type="docGroup.roleType"
      />
    </v-card>
  </div>
</template>

<script>
	import LibraryList from "./components/LibraryList";
	import {Library} from "@/api/generated/Library";

	export default {
		name: "LibraryView",

		components: {LibraryList},



		methods: {
			getRoleDisplayName(roleType) {
				const roleNames = {
					ADMINISTRATOR: "Administrator",
					LOCAL_ADMINISTRATOR: "Administrator lokalny",
					DEPARTMENT_EMPLOYEE: "Pracownik departamentu",
					AGENCY_EMPLOYEE: "Pracownik placówki",
					EXPERT: "Ekspert",
					BIDDER: "Oferent",
					SUB_BIDDER: "Oferent - subkonto",
					VOLUNTEER: "Wolontariusz",
					VIEWER: "Przeglądający"
				};
				return roleNames[roleType] || roleType;
			}
		},

		data() {
			return {
				documentGroups: []
			};
		},

		created() {
			loadLibraries(this);
		},
	};

	function loadLibraries(ctx) {
		Library.getAll(ctx, 
			successResponse => {
				ctx.documentGroups = successResponse.map(group => ({
					...group,
					documentType: ctx.getRoleDisplayName(group.roleType)
				}));
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować dokumentów", errorResponse);
			});
	}

</script>

<style scoped>
</style>
